
import Received from "../../../assets/outline/Received.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ReceivedIcon({ className, dataTestid = "ReceivedIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Received data-testid={dataTestid} className={classes} {...rest} />
  );
}
